import { render, staticRenderFns } from "./manage-notification.vue?vue&type=template&id=ae39a784&scoped=true"
import script from "./manage-notification.vue?vue&type=script&lang=ts"
export * from "./manage-notification.vue?vue&type=script&lang=ts"
import style0 from "./manage-notification.vue?vue&type=style&index=0&id=ae39a784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae39a784",
  null
  
)

export default component.exports